import { render, staticRenderFns } from "./ViewsController.vue?vue&type=template&id=09e8b5e2"
import script from "./ViewsController.vue?vue&type=script&lang=js"
export * from "./ViewsController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports